import React from "react";
import "./userEvents.scss";

import miscUtils from "utils/miscUtils";
import Moment from "react-moment";
import moment from "moment";
import ListsLoader from "components/contentLoaders/ListsLoader";
import { UserProfileContext } from "../UserProfile";
import { UserService } from "api/services/users";
import PaginationDropdown from "components/paginationDropdown";


const UserEvents = (props: {
  groupId: any;
  userId: any
}) => {
  const { userId } = props

  const { groupData } = React.useContext(UserProfileContext)

  const [loadingUserEvents, setLoadingUserEvents] = React.useState<boolean>(true);
  const [show, setShow] = React.useState('upcoming');
  const [userUpcomingRsvpEvents, setUserUpcomingRsvpEvents] = React.useState<any>(null);
  const [userPastRsvpEvents, setUserPastRsvpEvents] = React.useState<any>(null);

  const getUserUpcomingEvents = async () => {
    setLoadingUserEvents(true);
    await UserService.getInstance()
      .getUserRsvpEvents(groupData !== undefined && groupData, userId, 'upcoming')
      .then((res: any) => {
        setLoadingUserEvents(false);
        setUserUpcomingRsvpEvents(res);
      }).catch((error: any) => {
        setLoadingUserEvents(false);
        console.error(error)
      })
  };

  const getUserPastEvents = async () => {
    setLoadingUserEvents(true);
    await UserService.getInstance()
      .getUserRsvpEvents(groupData !== undefined && groupData, userId, 'past')
      .then((res: any) => {
        setLoadingUserEvents(false);
        setUserPastRsvpEvents(res);
      }).catch((error: any) => {
        setLoadingUserEvents(false);
        console.error(error);
      })
  };

  React.useEffect(() => {
    if(groupData && groupData.id) {
      if(show === 'upcoming') {
        getUserUpcomingEvents();
      }

      if(show === 'past') {
        getUserPastEvents();
      }
    }
  }, [groupData, show]);

  // group upcoming events by month
  // const upcomingEventsByMonth: any = {};
  // if (userUpcomingRsvpEvents) {
  //   for (const rsvpevent of userUpcomingRsvpEvents.data) {
  //     const month = moment(rsvpevent.start_time).format("MMMM YYYY");
  //     if (!upcomingEventsByMonth[month]) {
  //       upcomingEventsByMonth[month] = [rsvpevent];
  //     } else {
  //       upcomingEventsByMonth[month].push(rsvpevent);
  //     }
  //   }
  // }


  // group past events by month
  // const pastEventsByMonth: any = {};
  // if (userPastRsvpEvents) {
  //   for (const rsvpevent of userPastRsvpEvents.data) {
  //     const month = moment(rsvpevent.start_time).format("MMMM YYYY");
  //     if (!pastEventsByMonth[month]) {
  //       pastEventsByMonth[month] = [rsvpevent];
  //     } else {
  //       pastEventsByMonth[month].push(rsvpevent);
  //     }
  //   }
  // }


  const hasUpcomingOrPastEvents = () => {
    return (
      (
        userUpcomingRsvpEvents &&
        userUpcomingRsvpEvents.data &&
        Object.keys(userUpcomingRsvpEvents.data).length
      ) ||
      (
        userPastRsvpEvents &&
        userPastRsvpEvents.data &&
        Object.keys(userPastRsvpEvents.data).length
      )
    )
  }

  const loadMoreUpcomingEvents = async (pageNumber: number) => {
    await UserService.getInstance()
      .loadMoreUserRsvpEvents(groupData !== undefined && groupData, userId, 'upcoming', pageNumber)
      .then((res: any) => {
        if (res) {
          setUserUpcomingRsvpEvents(res);
        }
      }).catch((error: any) => console.error(error))
  };

  const loadMorePastEvents = async (pageNumber: number) => {
    await UserService.getInstance()
      .loadMoreUserRsvpEvents(groupData !== undefined && groupData, userId, 'past', pageNumber)
      .then((res: any) => {
        if (res) {
          setUserPastRsvpEvents(res);
        }
      }).catch((error: any) => console.error(error))
  };

  return (
    <>
      <div className="title-header">
          <>
            <span
              className={`${show === 'upcoming' ? 'title-header-upcoming selected-events' : 'title-header-upcoming'}`}
              onClick={() => setShow('upcoming')}
            >
              Upcoming events
            </span>

            <span
              className={`${show === 'past' ? 'title-header-past selected-events' : 'title-header-past'}`}
              onClick={() => setShow('past')}
            >
              Past events
            </span>
          </>
      </div>

      {
        loadingUserEvents ?
          <div className="events-loader user-profile-events-loader-container">
            <ListsLoader
              totalItems={20}
              padding={2}
              styles={{ background: "#FFFFFF", borderRadius: "6px" }}
            />
          </div>
          :
          <>
            {hasUpcomingOrPastEvents() ? 
              <>
                {show === 'upcoming' &&
                  <>
                    {userUpcomingRsvpEvents !== null && userUpcomingRsvpEvents.data && Object.keys(userUpcomingRsvpEvents.data).length ?
                      <>
                        {Object.keys(userUpcomingRsvpEvents.data).reverse().map((month, i) => (
                          <div key={i}>
                            <div className="past-events-month">{month}</div>
                            {userUpcomingRsvpEvents.data[month].reverse().map((rsvpevent: any, j: any) => (
                              <div key={j} className='user-event-container'>
                                <div className='user-event-container-date'>
                                  {
                                    moment.tz(rsvpevent.start_time, miscUtils.getUserTimezone()).utc().isSame(rsvpevent.end_time, "month") ?
                                      <div className="event-date">
                                        {miscUtils.isSameDayEvent(rsvpevent) ?
                                          <span className="date-days">
                                            <Moment utc={true} format="DD" tz={miscUtils.getUserTimezone()}>{rsvpevent.start_time}</Moment>

                                          </span>
                                          :
                                          <span className="date-days">
                                            <Moment utc={true} format="DD" tz={miscUtils.getUserTimezone()}>{rsvpevent.start_time}</Moment>
                                            <span>-
                                              <Moment utc={true} format="DD" tz={miscUtils.getUserTimezone()}>{rsvpevent.end_time}</Moment>
                                            </span>
                                          </span>
                                        }
                                        <span className="date-month">
                                          <Moment utc={true} format="MMMM" tz={miscUtils.getUserTimezone()}>{rsvpevent.end_time && rsvpevent.end_time.toUpperCase()}</Moment>
                                        </span>
                                      </div>
                                      :
                                      <div className="event-date-dual-month">
                                        <div className="event-date">
                                          <span className="date-days">
                                            <Moment utc={true} format="DD" tz={miscUtils.getUserTimezone()}>{rsvpevent.event.start_time}</Moment>
                                          </span>
                                          <span className="date-month">
                                            <Moment utc={true} format="MMMM" tz={miscUtils.getUserTimezone()}>{rsvpevent.event.start_time && rsvpevent.event.start_time.toUpperCase()}</Moment>
                                          </span>
                                        </div>
                                        <span className="to-hyphen">-</span>
                                        <div className="event-date">
                                          <span className="date-days">
                                            <Moment utc={true} format="DD" tz={miscUtils.getUserTimezone()}>{rsvpevent.event.end_time}</Moment>
                                          </span>
                                          <span className="date-month">
                                            <Moment utc={true} format="MMMM" tz={miscUtils.getUserTimezone()}>{rsvpevent.event.end_time && rsvpevent.event.end_time.toUpperCase()}</Moment>
                                          </span>
                                        </div>
                                      </div>
                                  }
                                </div>
                                <div className="user-event-container-details">
                                  <div className="event-details">
                                    <button className="event-name">
                                      <a href={`${rsvpevent.event.group && rsvpevent.event.group.url}/events/${rsvpevent.event.slug}`} target="_self">
                                        {rsvpevent.event.title}
                                      </a>
                                    </button>
                                    <span className="event-time">
                                      <Moment utc={true} format="h:mm A" tz={miscUtils.getUserTimezone()}>{rsvpevent.event.start_time}</Moment> - {" "}
                                      <Moment utc={true} format="h:mm A z" tz={miscUtils.getUserTimezone()}>{rsvpevent.event.end_time}</Moment>
                                      {miscUtils.getReadableTimezoneOffset(miscUtils.getUserTimezone()) && ` (${miscUtils.getReadableTimezoneOffset(miscUtils.getUserTimezone())})`}
                                    </span>
                                  </div>
                                  <div className="fresh-event">
                                    <Moment
                                      utc
                                      fromNow
                                      tz={miscUtils.getUserTimezone()}
                                    >
                                      {rsvpevent.event.start_time}
                                    </Moment>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ))}
                        <div className='user-authored-posts-pagination'>
                          <PaginationDropdown
                            currentPage={userUpcomingRsvpEvents.current_page}
                            lastPage={userUpcomingRsvpEvents.last_page}
                            onPageChanged={(page: any) => loadMoreUpcomingEvents(page)}
                          />
                        </div>
                      </>
                      :
                      <span className="empty-payload">No upcoming rsvp'd events yet.</span>
                    }
                  </>
                }

                {show === 'past' &&
                  <>
                    {userPastRsvpEvents !== null && userPastRsvpEvents.data && Object.keys(userPastRsvpEvents.data).length ?
                      <>
                        {Object.keys(userPastRsvpEvents.data).reverse().map((month, i) => (
                          <div key={i}>
                            <div className="past-events-month">{month}</div>
                            {userPastRsvpEvents.data[month].reverse().map((rsvpevent: any, j: any) => (
                              <div key={j} className='user-event-container'>
                                <div className='user-event-container-date'>
                                  {
                                    rsvpevent && moment.tz(rsvpevent.start_time, miscUtils.getUserTimezone()).utc().isSame(rsvpevent.end_time, "month") ?
                                      <div className="event-date">
                                        {miscUtils.isSameDayEvent(rsvpevent) ?
                                          <span className="date-days">
                                            <Moment utc={true} format="DD" tz={miscUtils.getUserTimezone()}>{rsvpevent.start_time}</Moment>
                                          </span>
                                          :
                                          <span className="date-days">
                                            <Moment utc={true} format="DD" tz={miscUtils.getUserTimezone()}>{rsvpevent.start_time}</Moment>
                                            <span>-
                                              <Moment utc={true} format="DD" tz={miscUtils.getUserTimezone()}>{rsvpevent.end_time}</Moment>
                                            </span>
                                          </span>
                                        }
                                        <span className="date-month">
                                          <Moment utc={true} format="MMMM" tz={miscUtils.getUserTimezone()}>{rsvpevent.end_time && rsvpevent.end_time.toUpperCase()}</Moment>
                                        </span>
                                      </div>
                                      :
                                      <>
                                      {
                                        rsvpevent &&
                                      <div className="event-date-dual-month">
                                        <div className="event-date">
                                          <span className="date-days">
                                            <Moment utc={true} format="DD" tz={miscUtils.getUserTimezone()}>{rsvpevent.start_time}</Moment>
                                          </span>
                                          <span className="date-month">
                                            <Moment utc={true} format="MMMM" tz={miscUtils.getUserTimezone()}>{rsvpevent.start_time && rsvpevent.start_time.toUpperCase()}</Moment>
                                          </span>
                                        </div>
                                        <span className="to-hyphen">-</span>
                                        <div className="event-date">
                                          <span className="date-days">
                                            <Moment utc={true} format="DD" tz={miscUtils.getUserTimezone()}>{rsvpevent.end_time}</Moment>
                                          </span>
                                          <span className="date-month">
                                            <Moment utc={true} format="MMMM" tz={miscUtils.getUserTimezone()}>{rsvpevent.end_time && rsvpevent.end_time.toUpperCase()}</Moment>
                                          </span>
                                        </div>
                                      </div>
                                      }
                                      </>
                                  }
                                </div>
                                <>
                                {
                                  rsvpevent &&
                                <div className="user-event-container-details">
                                  <div className="event-details">
                                    <button className="event-name">
                                      <a href={`${rsvpevent.group && rsvpevent.group.url}/events/${rsvpevent.slug}`} target="_self">
                                        {rsvpevent.title}
                                      </a>
                                    </button>
                                    <span className="event-time">
                                      <Moment utc={true} format="h:mm A" tz={miscUtils.getUserTimezone()}>{rsvpevent.start_time}</Moment> - {" "}
                                      <Moment utc={true} format="h:mm A z" tz={miscUtils.getUserTimezone()}>{rsvpevent.end_time}</Moment>
                                      {miscUtils.getReadableTimezoneOffset(miscUtils.getUserTimezone()) && ` (${miscUtils.getReadableTimezoneOffset(miscUtils.getUserTimezone())})`}
                                    </span>
                                  </div>
                                  <div className="fresh-event">
                                    <Moment
                                      utc
                                      fromNow
                                      tz={miscUtils.getUserTimezone()}
                                    >
                                      {rsvpevent.start_time}
                                    </Moment>
                                  </div>
                                </div>
                                }
                                </>
                              </div>
                            ))}
                          </div>
                        ))}
                        <div className='user-authored-posts-pagination'>
                          <PaginationDropdown
                            currentPage={userPastRsvpEvents.current_page}
                            lastPage={userPastRsvpEvents.last_page}
                            onPageChanged={(page: any) => loadMorePastEvents(page)}
                          />
                        </div>
                      </>
                      :
                      <span className="empty-payload">No past rsvp'd events yet.</span>
                    }
                  </>

                }
              </>
              :
              <span className="empty-payload">No rsvp'd events yet.</span>
            }
          </>
      }
    </>
  );
};

export default UserEvents
